import { Link } from "@tanstack/react-router";
import { ArrowRight, Quote } from "lucide-react";
import type { Block } from "@/content/posts";
import { Button } from "@/components/ui/button";

export function BlogArticle({ blocks }: { blocks: Block[] }) {
  return (
    <div className="space-y-6">
      {blocks.map((b, i) => {
        switch (b.kind) {
          case "p":
            return (
              <p key={i} className="text-base leading-relaxed text-foreground/90">
                {b.text}
              </p>
            );
          case "h2":
            return (
              <h2 key={i} className="mt-10 font-display text-2xl font-semibold tracking-tight">
                {b.text}
              </h2>
            );
          case "h3":
            return (
              <h3 key={i} className="mt-6 font-display text-xl font-semibold tracking-tight">
                {b.text}
              </h3>
            );
          case "ul":
            return (
              <ul key={i} className="ml-5 list-disc space-y-2 text-foreground/90">
                {b.items.map((it, j) => (
                  <li key={j} className="leading-relaxed">{it}</li>
                ))}
              </ul>
            );
          case "ol":
            return (
              <ol key={i} className="ml-5 list-decimal space-y-2 text-foreground/90">
                {b.items.map((it, j) => (
                  <li key={j} className="leading-relaxed">{it}</li>
                ))}
              </ol>
            );
          case "quote":
            return (
              <figure key={i} className="rounded-2xl border-l-4 border-primary bg-muted/40 px-5 py-4">
                <Quote className="h-4 w-4 text-primary" />
                <blockquote className="mt-2 font-display text-lg italic text-foreground">
                  {b.text}
                </blockquote>
                {b.cite && (
                  <figcaption className="mt-2 text-xs uppercase tracking-wider text-muted-foreground">
                    {b.cite}
                  </figcaption>
                )}
              </figure>
            );
          case "callout":
            return (
              <aside key={i} className="rounded-2xl border-2 border-primary/30 bg-primary/5 p-5">
                <p className="font-display text-sm font-semibold uppercase tracking-wider text-primary">
                  {b.title}
                </p>
                <p className="mt-2 text-sm leading-relaxed text-foreground/90">{b.text}</p>
              </aside>
            );
          case "cta":
            return (
              <div key={i} className="my-8 rounded-2xl border border-border bg-card p-6 text-center shadow-soft">
                <p className="font-display text-lg text-foreground">{b.text}</p>
                <Button asChild className="mt-4 shadow-glow">
                  <Link to={b.href}>
                    {b.label}
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Link>
                </Button>
              </div>
            );
        }
      })}
    </div>
  );
}
